import {
  COURSE_SLUG_SAT_BOOTCAMP_MATH,
  COURSE_SLUG_SAT_BOOTCAMP_READING,
} from '@/queries/constants'

export const COURSE_SLUG_TO_SERIES_ICON_URL: Record<string, string> = {
  [COURSE_SLUG_SAT_BOOTCAMP_MATH]: 'https://assets.schoolhouse.world/public/sat/sat-math-v2.svg',
  [COURSE_SLUG_SAT_BOOTCAMP_READING]:
    'https://assets.schoolhouse.world/public/sat/sat-reading-v2.svg',
}
